import HeadshotViewer from '../HeadshotViewer';

const wrapClasses = 'flex flex-col items-center text-center gap-3';

const nameClasses = 'text-lg font-bold text-content m-0';

const blurbClasses = 'text-base leading-relaxed text-content whitespace-pre-line m-0 max-w-prose';

const fallbackClasses = 'flex items-center justify-center h-28 w-28 rounded-full bg-primary text-white! text-3xl';

const PlannerProfileCard = ({ planner }) => {
    const fullName = [planner?.firstName, planner?.lastName].filter(Boolean).join(' ');

    return (
        <div className={wrapClasses}>
            {planner?.headshot?.url ? (
                <HeadshotViewer headshot={planner.headshot} imgClassName="w-28 h-28" />
            ) : (
                <span className={fallbackClasses}>
                    <i className="fas fa-user-md" />
                </span>
            )}
            {fullName ? <h4 className={nameClasses}>{fullName}</h4> : null}
            {planner?.blurbText ? <p className={blurbClasses}>{planner.blurbText}</p> : null}
        </div>
    );
};

export default PlannerProfileCard;
